import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { localeDArrivee } from '@/lib/locales'

/**
 * Route universelle `/call` (sans préfixe de locale).
 *
 * Détecte la locale préférée de l'utilisateur (localStorage > navigateur > défaut)
 * puis redirige vers `/{locale}/call?<params>` en préservant tous les query params
 * (notamment `?number=...&auto=1`).
 *
 * Sert d'URL publique stable documentée :
 *   https://app.callizy.ca/call?number=+14385551234
 */
export function CallRedirectPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const locale = localeDArrivee()
    const search = window.location.search || ''
    navigate(`/${locale}/call${search}`, { replace: true })
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A192F]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/70 text-sm">Préparation de l'appel…</p>
      </div>
    </div>
  )
}
